(()=>{
 let lifecycle;let cleanups=[];
 function initialize(){
 lifecycle?.abort();cleanups.forEach(fn=>fn());cleanups=[];lifecycle=new AbortController();const signal=lifecycle.signal;
 if(!document.getElementById('bf-public-start-layout'))return;
 const events=target=>({addEventListener:(type,handler)=>target?.addEventListener(type,handler,{signal})});
{const root=document.getElementById('bf-public-start-layout');if(!root)return;for(const family of ['security','platform']){const buttons=[...root.querySelectorAll('[data-'+family+'-key]')],detail=root.querySelector('#bx-'+family+'-detail');if(!detail)continue;function choose(key){buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.getAttribute('data-'+family+'-key')===key)));detail.querySelectorAll('[data-system-panel]').forEach(p=>p.hidden=p.dataset.systemPanel!==key);}buttons.forEach(b=>{const select=()=>choose(b.getAttribute('data-'+family+'-key'));events(b).addEventListener('click',select);events(b).addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')select();});events(b).addEventListener('focus',select);});}}
{
  const root=document.getElementById('bf-public-start-layout');
  const articles=[...root.querySelectorAll('[data-reflection]')];
  const buttons=[...root.querySelectorAll('[data-reflection-select]')];
  const media=matchMedia('(max-width:700px)');
  let selected=0;
  function render(){
    articles.forEach((article,index)=>{
      const button=article.querySelector('[data-reflection-select]');
      const paragraph=article.querySelector('.bx-reflect-panel');
      const expanded=!button||!media.matches||index===selected;
      paragraph.hidden=!expanded;
      button?.setAttribute('aria-expanded',String(expanded));
      if(media.matches)article.classList.toggle('is-current',index===selected);
    });
    if(media.matches)if(root.querySelector('#bx-reflection-number'))root.querySelector('#bx-reflection-number').textContent=String(selected+1).padStart(2,'0');
  }
  buttons.forEach(b=>events(b).addEventListener('click',()=>{
    selected=Number(b.dataset.reflectionSelect);
    articles.forEach((a,i)=>a.classList.toggle('is-current',i===selected));
    if(root.querySelector('#bx-reflection-number'))root.querySelector('#bx-reflection-number').textContent=String(selected+1).padStart(2,'0');
    render();
  }));
  events(media).addEventListener('change',render);render();
}


{
 const media=matchMedia('(max-width:768px)');
 const maps=[...document.querySelectorAll('.bx-security-map,.bx-platform-map')];
 const ns='http://www.w3.org/2000/svg';
 const diagrams=maps.map(map=>{
  const svg=document.createElementNS(ns,'svg');svg.classList.add('bx-mobile-relations');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');map.querySelector('.bx-mobile-relations')?.remove();map.append(svg);return {map,svg};
 });
 const draw=()=>diagrams.forEach(({map,svg})=>{
  svg.replaceChildren();if(!media.matches)return;
  const bounds=map.getBoundingClientRect(),hub=map.querySelector('.bx-device-shell,.bx-platform-hub').getBoundingClientRect();
  const cx=bounds.width/2,start=hub.bottom-bounds.top;
  const buttons=[...map.querySelectorAll('button')].map(n=>n.getBoundingClientRect());
  const ys=buttons.map(r=>r.top+r.height/2-bounds.top);
  svg.setAttribute('viewBox',`0 0 ${bounds.width} ${bounds.height}`);
  let d=`M ${cx} ${start+4} V ${Math.max(...ys)}`;
  buttons.forEach((r,i)=>{const left=(r.left+r.right)/2<bounds.left+cx;const end=left?r.right-bounds.left+7:r.left-bounds.left-7;d+=` M ${cx} ${ys[i]} H ${end}`});
  const path=document.createElementNS(ns,'path');path.setAttribute('d',d);svg.append(path);
 });
 const observer=new ResizeObserver(draw);cleanups.push(()=>observer.disconnect());maps.forEach(n=>observer.observe(n));events(media).addEventListener('change',draw);document.fonts.ready.then(()=>{if(!signal.aborted)draw();});draw();
}

}
 initialize();
 if(window.Shopify?.designMode)document.addEventListener('shopify:section:load',initialize);
})();
